var angular=window.angular,ngModule;
try {ngModule=angular.module(["ng"])}
catch(e){ngModule=angular.module("ng",[])}
var v1="<div class=\"questions\">\n<div class=\"questions__question\" ng-class=\"{active: question.en[0] === edit.currentQuestion.en[0]}\" ng-click=\"edit.setQuestion($index)\" ng-repeat=\"question in edit.questions track by $index\">{{question.en[0]}}</div>\n</div>\n";
var id1="edit/template/tabContentQuestion.html";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=v1;